export default {
      id: "oc-res-cloudgroup-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-cloudgroup",
      toString: function () {
        return this.url;
      }
    }